import * as React from "react";
import ModalRegistrazione from "@src/components/frontend/modals/ModalRegistrazione";
import FormRadio from "@src/components/ui/FormRadio";
import FormInput from "@src/components/ui/FormInput";

interface Props {
    header: string,
    onSave?: any,
    onCancel?: any
}

interface State {
    _modal_formazione_livello: string,
    _modal_formazione_tipologia: string,
}

export default class ModalFormazione extends React.Component<Props, State> {
    constructor(props) {
        super(props);

        this.state = {
            _modal_formazione_livello: "",
            _modal_formazione_tipologia: ""
        }
    }

    handleChange(field, value) {
        this.setState({
            [field]: value
        });
    }

    onSave() {
        let result = {
            name: this.state._modal_formazione_tipologia,
            desc: this.state._modal_formazione_livello
        };

        if(result.name === undefined || result.name === '' || result.desc === undefined || result.desc === '') {
            alert('Compilare il campo "Tipologia titolo"');
            return;
        }

        if(this.props.onSave)
            this.props.onSave(result);
    }

    render() {
        let items = [
            {
                key: "triennale",
                value: "Laurea triennale"
            },
            {
                key: "specialistica",
                value: "Laurea specialistica"
            },
            {
                key: "master",
                value: "Master"
            },
            {
                key: "altro",
                value: "Altro"
            }
        ];

        return (
            <ModalRegistrazione header={this.props.header} onSave={this.onSave.bind(this)} onCancel={this.props.onCancel}>
                <div className={"block-qa"}>
                    <span>3. Formazione universitaria</span>
                    <div className={"answer"}>
                        <FormRadio values={items} list={true} name="_modal_formazione_livello" labelClassname={"formation-radio"} onChange={this.handleChange.bind(this)}></FormRadio>
                    </div>
                </div>
                <div className={"row"} style={{ marginTop: "80px", maxWidth:"330px", marginLeft:"0px" }}>
                    <FormInput type={"text"} label="Tipologia titolo" placeholder={"Specificare tipologia titolo"} required name="_modal_formazione_tipologia" onChange={this.handleChange.bind(this)} />
                </div>
            </ModalRegistrazione>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/frontend/modals/ModalFormazione.tsx